// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let AgentProfilePhoto = require("../../common/Components/AgentProfilePhoto.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationParticipantsDisplay_participantsConnection_graphql = require("../../../__generated__/ConversationParticipantsDisplay_participantsConnection_graphql.bs.js");

let avatarStyles = "border-[3px] border-white";

let avatarClasses = "w-14 h-14 " + avatarStyles;

function ConversationParticipantsDisplay$ByParticipants(props) {
  let __showNames = props.showNames;
  let participants = props.participants;
  let showNames = __showNames !== undefined ? __showNames : true;
  let printAvatar = (p, classNameOpt, param) => {
    let className = classNameOpt !== undefined ? classNameOpt : avatarClasses;
    if (typeof p === "object" && p.TAG === "Agent") {
      return JsxRuntime.jsx(AgentProfilePhoto.make, {
        profilePhoto: p.fragmentRefs,
        className: className
      });
    }
    return JsxRuntime.jsx(AgentProfilePhoto.Avatar.make, {
      alt: "Anonymous participant",
      className: className
    });
  };
  let match = participants[0];
  let match$1 = participants[1];
  let tmp;
  if (showNames) {
    let __x = participants.map(n => {
      let displayName;
      let id;
      if (typeof n !== "object") {
        return "Agent chose to hide their name";
      }
      if (n.TAG === "Agent") {
        displayName = n.displayName;
        id = n.id;
      } else {
        displayName = n.displayName;
        id = n.id;
      }
      return JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: `/agents/` + id,
        className: "hover:underline",
        children: displayName
      });
    });
    tmp = JsxRuntime.jsx("div", {
      children: Utils.$$Array.pseudoJoin(", ", undefined, __x),
      className: "font-semibold line-clamp-1"
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: match !== undefined ? (
            match$1 !== undefined ? JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: printAvatar(match, TailwindMerge.twMerge([
                      avatarStyles,
                      "w-11 h-11"
                    ]), undefined),
                    className: "absolute bottom-0 right-0"
                  }),
                  JsxRuntime.jsx("div", {
                    children: printAvatar(match$1, TailwindMerge.twMerge([
                      avatarStyles,
                      "w-11 h-11"
                    ]), undefined),
                    className: "absolute top-0 left-0"
                  })
                ],
                className: "flex flex-row relative h-14 w-14"
              }) : JsxRuntime.jsx("div", {
                children: printAvatar(match, undefined, undefined)
              })
          ) : null
      }),
      tmp
    ],
    className: "flex flex-row space-x-2 items-center"
  });
}

let ByParticipants = {
  make: ConversationParticipantsDisplay$ByParticipants
};

let convertFragment = ConversationParticipantsDisplay_participantsConnection_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationParticipantsDisplay_participantsConnection_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationParticipantsDisplay_participantsConnection_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationParticipantsDisplay_participantsConnection_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationParticipantsDisplay_participantsConnection_graphql.node, convertFragment, fRef);
}

let ParticipantsConnectionFragment_membershipStatusV5_decode = ConversationParticipantsDisplay_participantsConnection_graphql.Utils.membershipStatusV5_decode;

let ParticipantsConnectionFragment_membershipStatusV5_fromString = ConversationParticipantsDisplay_participantsConnection_graphql.Utils.membershipStatusV5_fromString;

let ParticipantsConnectionFragment = {
  membershipStatusV5_decode: ParticipantsConnectionFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: ParticipantsConnectionFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationParticipantsDisplay(props) {
  let participantsConnection = RescriptRelay_Fragment.useFragment(ConversationParticipantsDisplay_participantsConnection_graphql.node, convertFragment, props.participantsConnection);
  let agent = UserSession.useAgentInfo();
  let participants = Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.map(participantsConnection, p => p.edges), [])).map(v => v.node).filter(v => {
    switch (v.__typename) {
      case "Agent" :
        return agent.id !== v.id;
      case "AnonymousConversationParticipant" :
      case "__unselected" :
        return true;
    }
  }).map(v => {
    switch (v.__typename) {
      case "Agent" :
        let match = v.membershipStatus;
        let id = v.id;
        let displayName = v.displayName;
        if (match === "TERMINATED") {
          return {
            TAG: "AgentTerminated",
            displayName: displayName,
            id: id
          };
        }
        return {
          TAG: "Agent",
          id: id,
          fragmentRefs: v.fragmentRefs,
          displayName: displayName
        };
      case "AnonymousConversationParticipant" :
      case "__unselected" :
        return "AnonymousConversationParticipant";
    }
  });
  return JsxRuntime.jsx(ConversationParticipantsDisplay$ByParticipants, {
    participants: participants,
    showNames: props.showNames
  });
}

let make = ConversationParticipantsDisplay;

exports.avatarStyles = avatarStyles;
exports.avatarClasses = avatarClasses;
exports.ByParticipants = ByParticipants;
exports.ParticipantsConnectionFragment = ParticipantsConnectionFragment;
exports.make = make;
/* Utils Not a pure module */
